import { TopBar } from "../../types/menuTypes";
import TopBarModal from "../modals/TopBarModal";

const TopBarIcons = ({ topbar }: { topbar: TopBar[] }) => {
  return (
    <>
      {topbar &&
        topbar
          .filter((route: any) => route.type === "topbar")
          .map((topBar: any) => {
            return <TopBarModal key={topBar.name} topBar={topBar} />;
          })}
    </>
  );
};

export default TopBarIcons;
